import TagManager from 'react-gtm-module';

const GTM_ID = 'GTM-PXN5R84';
const CUSTOM_DATA_LAYER_NAME = 'PageDataLayer';
const CUSTOM_PAGE_VIEW_EVENT = 'customPageView';
const CUSTOM_EVENT_CATEGORY = 'CustomEvents';

function initialize() {
  TagManager.initialize({
    gtmId: GTM_ID,
    dataLayerName: CUSTOM_DATA_LAYER_NAME,
  });
}

function customPageView({
  stepName,
  chainName,
  hotelName,
  reservationNumber,
  bookingIdentifier,
  partner,
}) {
  TagManager.dataLayer({
    dataLayer: {
      event: CUSTOM_PAGE_VIEW_EVENT,
      category: CUSTOM_EVENT_CATEGORY,
      stepName,
      chainName,
      hotelName,
      reservationNumber,
      bookingIdentifier,
      partner,
      timeStamp: new Date().toLocaleString(),
    },
    dataLayerName: CUSTOM_DATA_LAYER_NAME,
  });
}

function checkinStep({ stepName }) {
  TagManager.dataLayer({
    dataLayer: {
      event: CUSTOM_PAGE_VIEW_EVENT,
      category: CUSTOM_EVENT_CATEGORY,
      stepName,
      timeStamp: new Date().toLocaleString(),
    },
    dataLayerName: CUSTOM_DATA_LAYER_NAME,
  });
}

export { initialize, customPageView, checkinStep };
